import MonthlyProceduresDashboard from "./MonthlyProceduresDashboard";
import AssessorsRankingDashboard from "./AssessorsRankingDashboard";
import CardStatusDetailDashboard from "./CardStatusDetailDashboard";
import ConectaPkuDashboard from "./ConectaPkuDashboard";
import ConectaPkuTratamentoDashboard from "./ConectaPkuTratamentoDashboard";

const dashboardComponentMap = {
  // Chave deve corresponder ao DB (coluna configuracoes da model programas)
  monthly_procedures: MonthlyProceduresDashboard,
  assessors_ranking: AssessorsRankingDashboard,
  cards_status_detail: CardStatusDetailDashboard,
  conecta_pku_dashboard: ConectaPkuDashboard,
  conecta_pku_tratamento_dashboard: ConectaPkuTratamentoDashboard,
  // Adicione outras chaves/componentes conforme necessário
};

export default dashboardComponentMap;
